import { ActiveContractViewModel } from '../../../../business/model/crossroads/contracts-options/active-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { TypeContractEnum } from '../../../../business/model/crossroads/typeContractEnum';

export class RemoveContractUtils {
    /**
     * extract contracts from contractsViewModel
     * @param {ContractsViewModel[]}contracts
     * @return {ActiveContractViewModel[]}
     */
    public static extractActiveContract(contracts: ContractsViewModel[]): ActiveContractViewModel[] {
        return contracts
            .filter((contract) => contract.typeContract !== TypeContractEnum.PROTECTEDHOUSE)
            .map((map) => map.contract as ActiveContractViewModel);
    }
}
